import type { ViewNode } from "@e308/ux";
import { resolvePersonality } from "../bot-seed.js";
import { BOT_DIFFICULTIES, BOT_PERSONALITIES } from "../content/setup.js";
import type { AppIntent, AppState } from "./app-source.js";

export function botLobbyFields(state: AppState): ViewNode<AppIntent, string>[] {
  return [
    {
      kind: "select-input",
      id: "bot-personality",
      label: "Computer personality",
      value: state.lobby.botPersonality,
      options: [
        { value: "seeded-mix", label: "Seeded Mix" },
        ...BOT_PERSONALITIES.map((entry) => ({ value: entry.id, label: entry.name })),
      ],
      intent: (value) => ({
        kind: "set-bot-personality",
        value: value as AppState["lobby"]["botPersonality"],
      }),
    },
    {
      kind: "select-input",
      id: "bot-difficulty",
      label: "Computer difficulty",
      value: state.lobby.botDifficulty,
      options: BOT_DIFFICULTIES.map((entry) => ({
        value: entry.id,
        label: `${entry.name} — every ${entry.decisionSeconds}s`,
      })),
      intent: (value) => ({
        kind: "set-bot-difficulty",
        value: value as AppState["lobby"]["botDifficulty"],
      }),
    },
  ];
}

export function botControllerStatus(state: AppState): ViewNode<AppIntent, string> {
  const difficulty = BOT_DIFFICULTIES.find(
    (entry) => entry.id === state.lobby.botDifficulty,
  ) as (typeof BOT_DIFFICULTIES)[number];
  const names = Array.from({ length: state.lobby.aiCount }, (_, index) => {
    const personality = resolvePersonality(
      state.lobby.botPersonality,
      "6b696c6e66726f6e742d62726f777365722d7072616374696365",
      `ai-${index + 1}`,
    );
    const label = BOT_PERSONALITIES.find(
      (entry) => entry.id === personality,
    ) as (typeof BOT_PERSONALITIES)[number];
    return `Clockwork ${index + 1}: ${difficulty.name} ${label.name}`;
  });
  return {
    kind: "description",
    id: "computer-controller-status",
    content: [
      {
        kind: "text",
        value: `Computer controllers — ${names.join("; ")}. They use ordinary observations and legal orders.`,
      },
    ],
  };
}
